module.exports = __webpack_public_path__ + "static/media/lucky-monkey.c9daf173.jpg";